import React from 'react'

/* mui */
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
/* mui */

/* CONSTANTS */
const useStyles = makeStyles(theme => ({
  wrapp: {
    position: 'relative',
  },
}))
/* CONSTANTS */

const xl = props => {
  /* mui */
  const classes = useStyles()
  /* mui */

  return (
    <Grid className={classes.wrapp} item xs={8} sm={8} md={8} lg={8} xl={8}>
      {props.children}
    </Grid>
  )
}

export default xl
